import React from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { useLang } from "../i18n/LanguageContext";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  const { lang } = useLang();
  return (
    <main className="bg-[#F9F8F6] text-[#1A1A1A] font-body min-h-screen flex flex-col" data-testid="page-404">
      <Navbar transparentOnHome={false} />
      <section className="flex-1 flex items-center pt-32 pb-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 w-full">
          <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#8A5A44] mb-5">— 404</div>
          <h1 className="font-display text-6xl sm:text-7xl lg:text-9xl font-light tracking-tighter leading-[0.9]">
            {lang === "de" ? "Diese Diele fehlt." : "This plank is missing."}
          </h1>
          <p className="mt-8 text-[#4A4A4A] max-w-md">
            {lang === "de"
              ? "Die gesuchte Seite ist nicht verfügbar. Lassen Sie uns Ihnen anders helfen."
              : "The page you're looking for is unavailable. Let us help you a different way."}
          </p>
          <Link to="/" className="btn-primary mt-10" data-testid="404-home-link">
            {lang === "de" ? "Zur Startseite" : "Back home"} <ArrowRight size={16} />
          </Link>
        </div>
      </section>
      <Footer />
    </main>
  );
}
